<template>
  <div class="otp-boxes">
    <input
      v-for="(_, i) in digits"
      :key="i"
      :ref="'box' + i"
      :value="digits[i]"
      type="text"
      inputmode="numeric"
      maxlength="1"
      autocomplete="one-time-code"
      class="otp-box"
      @input="onInput(i, $event)"
      @keydown="onKeydown(i, $event)"
      @paste.prevent="onPaste($event)"
      @focus="$event.target.select()"
    />
  </div>
</template>

<script>
export default {
  name: 'OTPInput',
  props: {
    value: { type: String, default: '' }
  },
  data() {
    return {
      digits: ['', '', '', '', '', '']
    }
  },
  watch: {
    value(val) {
      if (!val) this.digits = ['', '', '', '', '', '']
    }
  },
  methods: {
    onInput(i, e) {
      const val = e.target.value.replace(/\D/g, '').slice(-1)
      this.$set(this.digits, i, val)
      this.$emit('input', this.digits.join(''))
      if (val && i < 5) {
        this.$nextTick(() => {
          const next = this.$refs['box' + (i + 1)]
          if (next && next[0]) next[0].focus()
        })
      }
    },
    onKeydown(i, e) {
      if (e.key === 'Backspace') {
        if (this.digits[i]) {
          this.$set(this.digits, i, '')
          this.$emit('input', this.digits.join(''))
        } else if (i > 0) {
          this.$set(this.digits, i - 1, '')
          this.$emit('input', this.digits.join(''))
          this.$nextTick(() => {
            const prev = this.$refs['box' + (i - 1)]
            if (prev && prev[0]) prev[0].focus()
          })
        }
        e.preventDefault()
      }
    },
    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text')
      const nums = text.replace(/\D/g, '').slice(0, 6).split('')
      nums.forEach((n, idx) => { if (idx < 6) this.$set(this.digits, idx, n) })
      // Rellenar con vacío si pegó menos de 6
      for (let j = nums.length; j < 6; j++) this.$set(this.digits, j, '')
      this.$emit('input', this.digits.join(''))
      const focusIdx = Math.min(nums.length, 5)
      this.$nextTick(() => {
        const ref = this.$refs['box' + focusIdx]
        if (ref && ref[0]) ref[0].focus()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.otp-boxes {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.otp-box {
  width: 46px;
  height: 54px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  color: var(--color-navy, #0e2a40);
  caret-color: transparent;
  outline: none;
  padding: 0;
  transition: border-color 0.15s, background-color 0.15s;

  &:focus {
    border-color: var(--color-steel, #0f69b4);
    background-color: #f0f7ff;
  }
}
</style>
